import { render, staticRenderFns } from "./PageBlockItem.vue?vue&type=template&id=1713c93e&scoped=true"
import script from "./PageBlockItem.vue?vue&type=script&lang=js"
export * from "./PageBlockItem.vue?vue&type=script&lang=js"
import style0 from "./PageBlockItem.vue?vue&type=style&index=0&id=1713c93e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713c93e",
  null
  
)

export default component.exports